<template>
    <div class="delete-record dialog-wraper">
        <p><span v-t="'Delrecordtip'" class="record-tip mr-8"></span><b v-if="text.strong">{{text.result}}</b><span v-if="!text.strong">{{text.result}}</span></p>
        <div v-if="!dialogData.sid && !shareList.length" :class="`delete-file-check ${checked ? 'selected' : ''}`" @click="docheck">
            <div class="checkbox"></div><span v-t="'Delfilestoo'"></span>
        </div>
        <div class="dialog-foot">
            <el-button size="mini" @click="close" v-cloak>{{$t('Cancel')}}</el-button><el-button :loading="doing" @click="dodelete" type="danger" size="mini" v-cloak>{{$t('Confirm')}}</el-button>
        </div>
    </div>
</template>

<script>
import { mapState,mapMutations, mapActions} from 'vuex';
export default {
    data(){
        return {
            checked: false
        }
    },
    computed:{
        ...mapState([
            'dialogData'
        ]),
        ...mapState('latest',[
            'fileids',
            'fileList',
            'shareList',
            'doing'
        ]),
        currentFile(){
            let len = this.fileids.length
            if (len) {
                return this.fileList.filter(item => this.fileids.indexOf(item.fileid) > -1)
            }else{
                return [this.dialogData]
            }
        },
        text(){
            return this.currentFile.length == 1 ? {strong: true, result:`「${this.currentFile[0].name}」`} : {strong: false, result: this.$t('Selectedfiles')}
        }
    },
    methods:{
        ...mapActions([
            'close'
        ]),
        ...mapActions('latest',[
            'deleteRecord'
        ]),
        docheck(){
            this.checked = !this.checked
        },
        dodelete(){
            let {fileid,groupid,sid} = this.dialogData
            this.deleteRecord({
                fileid,
                checked: this.checked,
                groupid,
                sid
            })
        }
    }
}
</script>

<style>
.record-tip{
    line-height: 16px;
}
.delete-file-check{
    margin-top: 8px;
    height: 26px;
    display: inline-flex;
    cursor: pointer;
    align-items: center;
    font-size: 12px;
    color: #2e68f8;
}
.delete-record .checkbox{
    display: inline-block;
    position: relative;
    margin: 0 8px 0 0;
    top: unset;
}
</style>


// WEBPACK FOOTER //
// src/components/dialog/file/DeleteRecord.vue